import { render, staticRenderFns } from "./showTypeArchive.vue?vue&type=template&id=0a6833c8&"
import script from "./showTypeArchive.vue?vue&type=script&lang=js&"
export * from "./showTypeArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports